import apiClient from './api';
import type { Note, SaveNotePayload, NoteType, ApiResponse } from '../types/api.types';

export const notesService = {
  async getNote(segmentId: number, noteType: NoteType): Promise<Note | null> {
    try {
      const response = await apiClient.get<Note>(`/notes/${segmentId}/${noteType}`);
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  async saveNote(payload: SaveNotePayload): Promise<Note> {
    const response = await apiClient.post<Note>('/save/note', payload);
    return response.data;
  },

  async deleteNote(segmentId: number, noteType: NoteType): Promise<ApiResponse> {
    const response = await apiClient.delete<ApiResponse>('/delete/note', {
      data: { segmentId, noteType },
    });
    return response.data;
  },
};
